import React from 'react';
import { useParams } from 'react-router';
import {
  Highlight,
  IconBannersWarning,
  LoadingSpinner,
  VStack,
} from '@adc/parallax-component-library';
import { useQuery } from '@tanstack/react-query';
import i18n from '../../utilities/i18n';
import { organizationQueryOptions } from '../../queryOptions';
import { useErrorMessageOnEntityView } from '../../hooks/useErrorMessageOnEntityView';
import OrganizationHeader from './organizationComponents/OrganizationHeader';

/**
 * Organization component that displays the details of a specific organization.
 * @returns {React.JSX.Element}
 */
export default function Organization() {
  const { organizationKey } = useParams();

  const organization = useQuery(
    organizationQueryOptions(
      { key: organizationKey },
      { enabled: !!organizationKey },
    ),
  );

  const errorMessage = useErrorMessageOnEntityView(
    organization.error,
    'Page_Organization.load_error',
  );

  return (
    <VStack gap="$2" height="100%">
      {organization.isError ? (
        <Highlight
          variant="danger"
          iconStart={
            <IconBannersWarning
              color="$neutral.0"
              accentColor="$support.danger.default"
            />
          }
          title={i18n.t('Page_Organization.load_error_title')}
          body={i18n.t(errorMessage)}
          testID="organization-error-banner"
        />
      ) : null}

      {organization.isPending ? (
        <VStack alignItems="center" justifyContent="center" flexGrow={1}>
          <LoadingSpinner testID="organization-loading" />
        </VStack>
      ) : null}

      {organization.isSuccess ? (
        <OrganizationHeader organization={organization.data} />
      ) : null}
    </VStack>
  );
}
